import Svg, { Mask, Path } from '@rd-core-svg/svg'
import type { FlagsSvgProps } from '../svg.types'

export const ApplePayEnabledSmall = (props: FlagsSvgProps) => {
  return (
    <Svg width={36} height={24} viewBox="0 0 36 24" fill="none" {...props}>
      <Mask id="path-1-inside-1_22078_3806" fill="white">
        <Path d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V20C36 22.2091 34.2091 24 32 24H4C1.79086 24 0 22.2091 0 20V4Z" />
      </Mask>
      <Path
        d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V20C36 22.2091 34.2091 24 32 24H4C1.79086 24 0 22.2091 0 20V4Z"
        fill="white"
      />
      <Path
        d="M4 0V1H32V0V-1H4V0ZM36 4H35V20H36H37V4H36ZM32 24V23H4V24V25H32V24ZM0 20H1V4H0H-1V20H0ZM4 24V23C2.34315 23 1 21.6569 1 20H0H-1C-1 22.7614 1.23858 25 4 25V24ZM36 20H35C35 21.6569 33.6569 23 32 23V24V25C34.7614 25 37 22.7614 37 20H36ZM32 0V1C33.6569 1 35 2.34315 35 4H36H37C37 1.23858 34.7614 -1 32 -1V0ZM4 0V-1C1.23858 -1 -1 1.23858 -1 4H0H1C1 2.34315 2.34315 1 4 1V0Z"
        fill="#303030"
        mask="url(#path-1-inside-1_22078_3806)"
      />
      <Path
        d="M10.5165 8.59241C10.7979 8.24527 10.9888 7.77916 10.9384 7.30286C10.5266 7.32306 10.024 7.57089 9.7331 7.9183C9.47186 8.21581 9.24064 8.70143 9.30092 9.15777C9.76321 9.19733 10.2251 8.92981 10.5165 8.59241Z"
        fill="#303030"
      />
      <Path
        d="M10.9329 9.24684C10.2616 9.20739 9.69075 9.62274 9.37015 9.62274C9.04937 9.62274 8.55842 9.26672 8.02741 9.27632C7.33628 9.28634 6.69499 9.67185 6.34427 10.285C5.62289 11.5116 6.1539 13.3311 6.85539 14.3301C7.19606 14.8243 7.60661 15.3685 8.14758 15.349C8.65871 15.3292 8.85905 15.0225 9.48035 15.0225C10.1012 15.0225 10.2817 15.349 10.8227 15.3391C11.3838 15.3292 11.7346 14.8446 12.0752 14.3499C12.4661 13.7865 12.626 13.2425 12.6361 13.2126C12.626 13.2027 11.5542 12.797 11.5442 11.5806C11.5341 10.5621 12.3858 10.0776 12.4258 10.0476C11.9449 9.34585 11.1934 9.26672 10.9329 9.24684Z"
        fill="#303030"
      />
      <Path
        d="M16.7787 7.86847C18.2378 7.86847 19.2539 8.86076 19.2539 10.3055C19.2539 11.7553 18.2169 12.7528 16.7421 12.7528H15.1265V15.2874H13.9592V7.86847L16.7787 7.86847ZM15.1265 11.7862H16.4658C17.4821 11.7862 18.0605 11.2464 18.0605 10.3106C18.0605 9.37495 17.4821 8.84023 16.4711 8.84023H15.1265V11.7862Z"
        fill="#303030"
      />
      <Path
        d="M19.5591 13.7502C19.5591 12.8041 20.2939 12.2232 21.5969 12.1512L23.0976 12.0638V11.6474C23.0976 11.0459 22.6859 10.686 21.9981 10.686C21.3466 10.686 20.94 10.9944 20.8411 11.4778H19.778C19.8405 10.5008 20.6847 9.78107 22.0398 9.78107C23.3686 9.78107 24.2181 10.4752 24.2181 11.56V15.2874H23.1393V14.398H23.1133C22.7955 14.9996 22.1023 15.38 21.3831 15.38C20.3096 15.38 19.5591 14.7219 19.5591 13.7502ZM23.0976 13.2618V12.8351L21.7478 12.9173C21.0756 12.9636 20.6952 13.2567 20.6952 13.7194C20.6952 14.1923 21.0912 14.5008 21.6958 14.5008C22.4827 14.5008 23.0976 13.9661 23.0976 13.2618Z"
        fill="#303030"
      />
      <Path
        d="M25.2367 17.2773V16.3775C25.3199 16.398 25.5075 16.398 25.6014 16.398C26.1225 16.398 26.404 16.1821 26.5759 15.6269C26.5759 15.6166 26.675 15.2979 26.675 15.2927L24.6947 9.87885H25.914L27.3004 14.2799H27.3211L28.7075 9.87885H29.8957L27.8422 15.5703C27.3734 16.8814 26.8314 17.303 25.6953 17.303C25.6014 17.303 25.3199 17.2926 25.2367 17.2773Z"
        fill="#303030"
      />
    </Svg>
  )
}
